import { render, staticRenderFns } from "./overseasWarehouseConfigModule.vue?vue&type=template&id=3294725d&scoped=true"
import script from "./overseasWarehouseConfigModule.vue?vue&type=script&lang=js"
export * from "./overseasWarehouseConfigModule.vue?vue&type=script&lang=js"
import style0 from "./overseasWarehouseConfigModule.vue?vue&type=style&index=0&id=3294725d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294725d",
  null
  
)

export default component.exports